module.exports = __webpack_public_path__ + "static/media/lock4.502f2397.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/lock4.svg
// module id = 3144
// module chunks = 7